import React, {useEffect, useState} from 'react';

import {TemplateCollection} from 'notebook/entry-templates/TemplateConstants';
import TemplateDAO from 'notebook/entry-templates/TemplateDAO';
import ConfigureExecutionTemplateModalBody, {
  ExecutionTemplateType,
} from 'processes/settings/ConfigureExecutionTemplateModalBody';
import {ButtonStyle} from 'ui-library/buttons/Button';
import Modal from 'ui-library/modals/Modal';

interface ConfigureExecutionTemplateModalProps {
  initialTemplateCollectionId?: string | null;
  templateName?: string | null;
  sourceTemplateId?: string | null;
  modalTitle: string;
  onRequestClose: () => void;
  onRequestSubmit: (returnValue: {
    templateCollection: TemplateCollection;
    newTemplateName: string;
    sourceTemplateId: string | null;
  }) => void;
}

export default function ConfigureExecutionTemplateModal(
  props: ConfigureExecutionTemplateModalProps
): JSX.Element {
  const [templateCollections, setTemplateCollections] = useState<Array<TemplateCollection> | null>(null);
  const [executionTemplateType, setExecutionTemplateType] = useState(
    props.sourceTemplateId != null
      ? ExecutionTemplateType.CLONE_EXISTING_TEMPLATE
      : ExecutionTemplateType.CREATE_BLANK_TEMPLATE
  );
  const [selectedTemplateCollection, setSelectedTemplateCollection] = useState<TemplateCollection | null>(
    null
  );
  const [templateName, setTemplateName] = useState(props.templateName ?? '');
  const [sourceTemplateId, setSourceTemplateId] = useState<string | null>(props.sourceTemplateId ?? null);

  useEffect(() => {
    TemplateDAO.fetchCollections('write').done((collections: Array<TemplateCollection>) => {
      setTemplateCollections(collections);
      const initialTemplateCollection = collections.find(
        (collection) => collection.id === props.initialTemplateCollectionId
      );
      setSelectedTemplateCollection(initialTemplateCollection ?? null);
    });
  }, [props.initialTemplateCollectionId]);

  return (
    <Modal
      buttons={[
        {
          submit: true,
          text: 'Create',
          disabled:
            selectedTemplateCollection == null ||
            templateName.trim().length === 0 ||
            (executionTemplateType === ExecutionTemplateType.CLONE_EXISTING_TEMPLATE &&
              sourceTemplateId == null),
          style: ButtonStyle.SECONDARY,
        },
      ]}
      onRequestClose={props.onRequestClose}
      onRequestSubmit={() => {
        props.onRequestSubmit({
          templateCollection: selectedTemplateCollection!,
          newTemplateName: templateName.trim(),
          sourceTemplateId:
            executionTemplateType === ExecutionTemplateType.CLONE_EXISTING_TEMPLATE ? sourceTemplateId : null,
        });
      }}
      title={props.modalTitle}
    >
      <ConfigureExecutionTemplateModalBody
        templateCollections={templateCollections}
        templateName={templateName}
        setTemplateName={setTemplateName}
        selectedTemplateCollection={selectedTemplateCollection}
        setSelectedTemplateCollection={setSelectedTemplateCollection}
        sourceTemplateId={sourceTemplateId}
        setSourceTemplateId={setSourceTemplateId}
        executionTemplateType={executionTemplateType}
        setExecutionTemplateType={setExecutionTemplateType}
        toggleGroupOptions={[
          {
            id: ExecutionTemplateType.CREATE_BLANK_TEMPLATE,
            buttonProps: {
              text: 'Create blank template',
            },
          },
          {
            id: ExecutionTemplateType.CLONE_EXISTING_TEMPLATE,
            buttonProps: {
              text: 'Duplicate existing template',
            },
          },
        ]}
      />
    </Modal>
  );
}
